import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import {PayPalScriptProvider} from "@paypal/react-paypal-js";
import {useServices} from "../../../../hooks/use-services.hook";

/*
function prepareLocale(languageCode: string) {
    const parts = languageCode.split('-');
    return `${parts[0].toLowerCase()}_${parts[1].toUpperCase()}`;
}

 */

/*
const PayPalSdkReload: React.FC<{booking: IBookingViewModel}> = observer((props) => {
    const services = useServices();
    const [{options}, dispatch] = usePayPalScriptReducer();
    useEffect(() => {
        const r = reaction(() => {
            return {
                currency: props.booking.currency,
                currentLanguage: services.language.currentLanguage
            }
        }, (data) => {
            dispatch({
                type: DISPATCH_ACTION.RESET_OPTIONS,
                value: {
                    ...options,
                    currency: data.currency,
                    //locale: prepareLocale(data.currentLanguage)
                }
            })
        });

        return () => r();
    }, [dispatch, options, props.booking.currency, services.language.currentLanguage]);

    return (
        <></>
    );
});
*/

interface PayPalSdkLoaderProps extends  PropsWithChildren {

}

export const PayPalSdkLoader: React.FC<PayPalSdkLoaderProps> = observer((props) => {
    const services = useServices();
    const booking = services.booking.current;

    if(!services.configuration.data.pspConfigs?.PayPal?.clientId) {
        return (
            <>
                {props.children}
            </>
        );
    }

/*
    const getBuyerCountry = () => {

        return services.configuration.defaultCountryCode;
    }
*/

    try {
        return (
            <PayPalScriptProvider options={{
                clientId: services.configuration.data.pspConfigs.PayPal.clientId,
                environment: services.configuration.data.pspConfigs.PayPal.environment,
                components: ['buttons', 'messages'],
                intent: 'authorize',
                commit: true,
                currency: booking.currency,
                //buyerCountry: getBuyerCountry(),
                //disableFunding: ['card', 'paylater', 'bancontact', 'blik', 'venmo'],
                //locale: prepareLocale(services.language.currentLanguage)

            }}>
                {/*<PayPalSdkReload booking={props.booking} />*/}
                {props.children}
            </PayPalScriptProvider>
        )
    } catch (err) {
        services.logger.error('Failed to load PayPal script', err);
        return (
            <>
                {props.children}
            </>
        );
    }

})